export default __webpack_public_path__ + "static/media/service1.9db42235.svg";